export const projects = [{
    id: 1,
    name: "Interview Reports",
    img: "/images/reports.png",
    code: "https://github.com/vesnaguja/interview-reports",
    text: "A SPA for tracking information about companies, candidates and job interviews."
  },
  {
    id: 2,
    name: "Marvel Heroes Team",
    img: "/images/marvel.png",
    code: "https://github.com/vesnaguja/marvel-heroes-team",
    live: "https://vesnaguja.github.io/marvel-heroes-team/",
    text: "A SPA for searching, browsing and adding heroes to “My team”."
  },

  {
    id: 3,
    name: "React Users",
    img: "/images/react-users.png",
    code: "https://github.com/vesnaguja/react-users",
    live: "https://vesnaguja.github.io/react-users/",
    text: "A SPA for searching users and displaying results in list or grid view."
  },

  {
    id: 4,
    name: "Rick And Morty",
    img: "/images/rick-and-morty.png",
    code: "https://github.com/vesnaguja/RickAndMorty",
    live: "https://vesnaguja.github.io/RickAndMorty/",
    text: "A web application for browsing Rick and Morty characters."
  },

  {
    id: 5,
    name: "Bit Show",
    img: "/images/bit-show.png",
    code: "https://github.com/vesnaguja/BitShow",
    live: "https://vesnaguja.github.io/BitShow/",
    text: "An application for searching TV shows and displaying detailed info for each show."
  }
]